import React, { useState, useEffect } from "react";
import axios from "axios";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import sweetAlertStyle from "../../assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "../../services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import { postUser } from "../../services/ConfigServices";
import styled from "styled-components";
import { optionsData } from "variables/lists/users"
import AutocompleteMultiselectInputById from "components/Input/AutocompleteMultiselectInputById.js";

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "60ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

const emailPattern = new RegExp(
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i
);
const phoneRegex = /^(0[67]\d{8})$/;

function EditUserDialog(props) {
  const { closeModal, refetch, setLoading, setNotification } = props;
  const sweetClasse = UseSweetAlertStyle();
  const currentusertype = localStorage.getItem('userType');
  const handleSubmit = (event) => {
    updateUser(event);
    setLoading(true);
    closeModal();
  };

  useEffect(() => {
    let error = false;
    if (phonenumber && !phonenumber.match(phoneRegex)) {
      setPhonenumberError(true);
      error = true;
    } else setPhonenumberError(false);
    if (!error) {
      if (usertype < 0) error = true;
      else if (
        usertype != 1 &&
        (!userview || groups?.length == 0 || (usertype == 0 && !userpermission))
      )
        error = true;
      else if (usertype == 1 && !userview) error = true;
      else error = false;
    }
    setButtonDisabled(error);
  });

  const updateUser = async (event) => {
    axios
      .put(
        postUser(),
        {
          id: props.userid,
          usertype,
          groups,
          userpermission,
          userview,
          memv2version,
          options,
          phonenumber,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          setNotification("success", "Utilisateur modifié");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        setLoading(false);
      });
  };

  const [usertype, setUsertype] = React.useState(props.usertype);
  const [userpermission, setUserpermission] = React.useState(
    props.userpermission
  );
  const [userview, setUserview] = React.useState(props.userview);
  const [groups, setGroups] = React.useState(props.usergroups);
  const [memv2version, setMemv2version] = React.useState(props.memv2version);
  const [options, setOptions] = React.useState(props.options || []);
  const [phonenumber, setPhonenumber] = React.useState(props.phonenumber);
  const [phonenumberError, setPhonenumberError] = React.useState(false);

  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [emailError, setEmailError] = React.useState(false);

  const handleTypeChange = (event) => {
    setUsertype(event.target.value);
  };

  const handlePermissionChange = (event) => {
    setUserpermission(event.target.value);
  };

  const handleUserviewChange = (event) => {
    setUserview(event.target.value);
  };

  const handleMemv2versionChange = (event) => {
    setMemv2version(event.target.value);
  };

  const handleOptionsChange = (newValue) => {
    let newArray = [];
    for (let i = 0; i < newValue.length; i++) {
      newArray.push(newValue[i]);
    }
    setOptions(newArray);
  };

  console.log("once here");

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <div style={{ marginTop: "0.6rem" }}>
              <TextField
                disabled
                variant="outlined"
                id="nom-required"
                className={classes.textField}
                style={{ margin: 8, width: "30ch" }}
                defaultValue={props.lastNameValue}
              />
              <TextField
                disabled
                variant="outlined"
                id="prenom-required"
                className={classes.textField}
                style={{ margin: 8, width: "30ch" }}
                defaultValue={props.firstNameValue}
              />
            </div>
            <div>
              <TextField
                disabled
                variant="outlined"
                id="email-outlined-full-width"
                className={classes.textField}
                style={{ margin: 8, width: "62ch" }}
                defaultValue={props.emailValue}
              />
            </div>
            <div>
              <TextField
                error={phonenumberError}
                variant="outlined"
                id="phone-outlined-full-width"
                className={classes.textField}
                label="Numéro de téléphone"
                style={{ margin: 8, width: "62ch" }}
                defaultValue={phonenumber}
                onChange={(e) => {
                  setPhonenumber(e.target.value);
                }}
                helperText={phonenumberError ? "Numéro invalide (ex: 0612345678)" : ""}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <FormControl
                required
                variant="outlined"
                className={classes.formControl}
              >
                <InputLabel id="userView-simple-select-outlined-label">
                  Vue
                </InputLabel>
                <Select
                  labelId="userView-simple-select-outlined-label"
                  id="userView-simple-select-outlined"
                  label="Userview"
                  value={userview}
                  className={classes.textField}
                  onChange={handleUserviewChange}
                >
                  {props.viewlist.map(({ id, name }) => (
                    <MenuItem key={id} value={id}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                required
                variant="outlined"
                className={classes.formControl}
              >
                <InputLabel id="type-simple-select-outlined-label">
                  Type
                </InputLabel>
                <Select
                  labelId="type-simple-select-outlined-label"
                  id="type-simple-select-outlined"
                  label="Type"
                  value={usertype}
                  className={classes.textField}
                  onChange={handleTypeChange}
                >
                  <MenuItem key={0} value={0}>Utilisateur</MenuItem>
                  {currentusertype == 1 ? <MenuItem key={1} value={1}>Administrateur</MenuItem> : <></>}
                  <MenuItem key={3} value={3}>Administrateur MEM</MenuItem>
                </Select>
              </FormControl>
              {usertype !== 0 ? (
                <div></div>
              ) : (
                <FormControl
                  required
                  variant="outlined"
                  className={classes.formControl}
                >
                  <InputLabel id="permission-simple-select-outlined-label">
                    Permission
                  </InputLabel>
                  <Select
                    labelId="permission-simple-select-outlined-label"
                    id="permission-simple-select-outlined"
                    label="Permission"
                    value={userpermission}
                    className={classes.textField}
                    onChange={handlePermissionChange}
                  >
                    {props.permissionlist.map(({ id, name }) => (
                      <MenuItem key={id} value={id}>
                        {name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              {currentusertype == 1 ?
                <>
                  <FormControl
                    required
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel id="type-simple-select-outlined-label">
                      Version MEMV2
                    </InputLabel>
                    <Select
                      labelId="type-simple-select-outlined-label"
                      id="type-simple-select-outlined"
                      label="Type"
                      value={memv2version}
                      className={classes.textField}
                      onChange={handleMemv2versionChange}
                    >
                      <MenuItem key={0} value={0}>Silver</MenuItem>
                      <MenuItem key={1} value={1}>Gold</MenuItem>
                      <MenuItem key={2} value={2}>Platinum</MenuItem>
                    </Select>
                  </FormControl>
                  <AutocompleteMultiselectInputById
                    inputTitle={"Options"}
                    selected={options}
                    list={optionsData}
                    handleChange={handleOptionsChange}
                    specialWidth={"94%"}
                  />
                </>
                : <></>}
            </div>
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Modifier
            </Button>
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div
              className={
                usertype == 1 ? classes.treeHidden : classes.treeVisible
              }
            >
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={props.usergroups}
                  multiSelect={true}
                />
              </ImageList>
            </div>
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default EditUserDialog;
